/**
 * Debug logging utility with toggleable output.
 * Toggle via DebugMenu (SHIFT+D) or set localStorage.debugEnabled = 'true'
 */
class DebugLogger {
  static enabled = localStorage.getItem('debugEnabled') === 'true';

  static setEnabled(value) {
    this.enabled = value;
    localStorage.setItem('debugEnabled', value.toString());
  }

  static log(...args) {
    if (this.enabled) console.log('[DEBUG]', ...args);
  }

  static warn(...args) {
    console.warn(...args);
  }

  static error(...args) {
    console.error(...args);
  }
}

export const debug = DebugLogger;
